import { Header, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import ChatHistory from "@/components/chat-history/ChatHistory";
import NewChatButton from "@/components/layout/NewChatButton";

const AdminChatHistoryPage: React.FC = () => (
  <SpaceBetween size="xl">
    <Header
      variant="h1"
      description="Management tool for viewing the comprehensive chat history of each user in MAMBA."
      actions={<NewChatButton />}
    >
      Chat History
    </Header>
    <ChatHistory />
  </SpaceBetween>
);

export default AdminChatHistoryPage;
